module.exports = __webpack_public_path__ + "media/addons/USB-9d3e78e8.svg";